<template>
    <!-- User Profile Personal Basic Info Tab Content View From Account Profile -->
    <div>
        <div class="tabs-content-secondblock">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ml-2 mr-1 mb-3">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="infoHeader mt-4 py-6 px-4">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <a class="top-tabs-reminders d-flex align-items-center justify-content-center fw-600"
                                            role="tab" aria-controls="basictab" aria-expanded="true"
                                            aria-selected="false" :class="{ active: toView === 'birthdayView'}"
                                            @click="changeView('birthdayView')">
                                            <span>Birthdays</span>
                                        </a>
                                        <a class="top-tabs-reminders d-flex align-items-center justify-content-center fw-600 mx-20"
                                            role="tab" aria-controls="basictab" aria-expanded="true"
                                            aria-selected="false" :class="{ active: toView === 'eventsView'}"
                                            @click="changeView('eventsView')">
                                            <span>Events</span>
                                        </a>
                                        <a class="top-tabs-reminders-disabled d-flex align-items-center justify-content-center fw-600"
                                            role="tab" aria-controls="basictab" aria-expanded="true"
                                            aria-selected="false">
                                            <span>Digi Apps</span>
                                        </a>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center w-100"
                                        v-if="birthday_loading">
                                        <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                                            style="margin: 0 auto;" />
                                    </div>
                                    <div v-if="toView === 'birthdayView'">
                                        <div class="d-flex align-items-center justify-content-center w-100"
                                            v-if="!birthday_loading && !birthdays.length">
                                            <span class="fw-600 fs-18">No Birthdays Found!</span>
                                        </div>
                                        <div class="row mt-10">
                                            <div class="col-6 my-4" v-for="(data,index) in birthdays" :key="index">
                                                <div class="dataTab d-flex flex-row align-items-center pb-2">
                                                    <div class="mx-3">
                                                        <img :src="data.profile_pic"
                                                            style="width: 6em; border-radius: 40px; height: 6em;" />
                                                        <el-dropdown
                                                            v-if="edit_birthdays.includes(data.common_id) || add_birthdays.includes(data.common_id)"
                                                            trigger="click"
                                                            style="position: absolute; margin-top: 42px; margin-left: -18px; width: 14px;">
                                                            <span class="el-dropdown-link">
                                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/pic-options-icon.svg"
                                                                    style="height: 12px;" />
                                                            </span>
                                                            <el-dropdown-menu slot="dropdown"
                                                                style="border-radius: 0 !important">
                                                                <el-dropdown-item class="mx-1"
                                                                    style="box-shadow: 0 0.5px rgba(0, 0, 0, 0.33)">
                                                                    <span
                                                                        @click="data.profile_pic = 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'">
                                                                        <img class="mr-2"
                                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/trash-red.svg"
                                                                            style="height: 12px;" />
                                                                        Remove Photo
                                                                    </span>
                                                                </el-dropdown-item>
                                                                <el-dropdown-item class="mx-1">
                                                                    <label class="pointer">
                                                                        <input type="file"
                                                                            accept="image/x-png, image/gif, image/jpeg"
                                                                            @change="onProfilePicChange($event,index)" />
                                                                        <img class="mr-2"
                                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/gallery-icon.svg"
                                                                            style="height: 12px;" />
                                                                        Upload from Gallery
                                                                    </label>
                                                                </el-dropdown-item>
                                                            </el-dropdown-menu>
                                                        </el-dropdown>
                                                    </div>
                                                    <div class="d-flex flex-column mx-3 w-100" style="width: 14em;"
                                                        :style="edit_birthdays.includes(data.common_id) || add_birthdays.includes(data.common_id) ? '' : ' overflow: hidden;'">
                                                        <div class="d-flex justify-content-between align-items-center">
                                                            <input
                                                                v-if="edit_birthdays.includes(data.common_id) || add_birthdays.includes(data.common_id)"
                                                                v-validate="'required'" class="inputField" type="text"
                                                                :name="'name'+index" v-model="data.name"
                                                                placeholder="Enter Name"
                                                                style="line-height: 30px !important; padding: 0 !important; width: 60% !important" />
                                                            <el-tooltip class="item" effect="light" :content="data.name"
                                                                placement="top">
                                                                <span
                                                                    v-if="!edit_birthdays.includes(data.common_id) && !add_birthdays.includes(data.common_id)"
                                                                    style="line-height: 20px; font-size: 15px; font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ data.name }}</span>
                                                            </el-tooltip>
                                                            <div class="d-flex flex-row">
                                                                <a v-if="!(edit_birthdays.includes(data.common_id)) && !(add_birthdays.includes(data.common_id))"
                                                                    @click="editBirthday(index)"
                                                                    style="cursor: pointer">
                                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/edit-dark.svg"
                                                                        style="height: 12px;" />
                                                                </a>
                                                                <a v-if="!(edit_birthdays.includes(data.common_id)) && !(add_birthdays.includes(data.common_id))"
                                                                    @click="deleteBirthday(data._id,index)"
                                                                    style="cursor: pointer">
                                                                    <img class="ml-2"
                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/trash-red.svg"
                                                                        style="height: 12px;" />
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <date-picker
                                                            v-if="edit_birthdays.includes(data.common_id) || add_birthdays.includes(data.common_id)"
                                                            v-model="data.date_of_birth" :first-day-of-week="7"
                                                            :not-after="new Date()" :name="'date_of_birth'+index"
                                                            class="calendarYear mx-left calendar-edit-per pr-4"
                                                            format="DD/MM/YYYY" lang="en" v-validate="'required'"
                                                            :clearable="false" :editable="false" :value-type="valueType"
                                                            confirm confirm-text="APPLY" style="width: 64% !important">
                                                        </date-picker>
                                                        <span
                                                            v-if="!edit_birthdays.includes(data.common_id) && !add_birthdays.includes(data.common_id)"
                                                            style="line-height: 20px; font-size: 13px;">{{ moment(data.date_of_birth).format("DD/MM/YYYY") }}</span>
                                                        <multiselect
                                                            v-if="edit_birthdays.includes(data.common_id) || add_birthdays.includes(data.common_id)"
                                                            :max-height="200" class="digi-multiselect loaderbg"
                                                            v-model="data.relationship" :name="'relation'+index"
                                                            :options="relations" :searchable="true"
                                                            :close-on-select="true" :show-labels="false"
                                                            style="width: 60% !important">
                                                            <template slot="noOptions">
                                                                <div class="text-secondary text-center fw-600">List is
                                                                    Empty</div>
                                                            </template>
                                                            <template slot="noResult">
                                                                <div class="text-secondary text-center fw-600">No
                                                                    Results Found</div>
                                                            </template>
                                                        </multiselect>
                                                        <span
                                                            v-if="!edit_birthdays.includes(data.common_id) && !add_birthdays.includes(data.common_id)"
                                                            style="line-height: 20px; font-size: 10px;">{{ data.relationship }}</span>
                                                    </div>
                                                </div>
                                                <span class="invalid-feedback-form text-danger mb-5"
                                                    style="margin-top: 4px !important;"
                                                    v-if="check_birthday_date && index == birthdays.length-1">Birth
                                                    details is required</span>
                                            </div>
                                            <div class="col-12 d-flex justify-content-end pr-10 my-5">
                                                <button v-if="birthdays.length" class="btn btn-new-danger btn-smm mr-3"
                                                    @click="deleteAllBirthdays">- Delete All</button>
                                                <button class="btn btn-new-green btn-smm" @click="addBirthday">+ Add
                                                    Birthday</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-10" v-if="toView === 'eventsView'">
                                        <div class="col-12 d-flex justify-content-between align-items-center">
                                            <span
                                                style="color: #005dae; font-weight: 600; font-size: 18px;">{{selectedDate}}</span>
                                            <div class="d-flex align-items-center">
                                                <date-picker v-if="pickDate" v-model="dateRange" type="datetime"
                                                    :first-day-of-week="7" data-vv-scope="profile_data"
                                                    data-vv-as="Date Of Birth" name="date_of_birth"
                                                    class="calendarYear mx-left no-icon with-shortcuts mr-6"
                                                    format="DD-MM-YYYY HH:MM A" lang="en" :clearable="false"
                                                    :editable="false" :minute-step="1"
                                                    :popup-style="{ top: '100%', right: 0 }"
                                                    :shortcuts="datePickShortcuts" confirm :value-type="valueType" range
                                                    confirm-text="APPLY" @confirm="getEventsFiltered"
                                                    style="width: 23.5em !important;">
                                                </date-picker>
                                                <button class="mr-6" @click="pickDate = !pickDate"
                                                    style="background: transparent; cursor: pointer;">
                                                    <img
                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/calendar-setting-default-blue.svg" />
                                                </button>
                                                <button type="button"
                                                    class="btn btn-new-primary btn-smm d-flex align-items-center float-right"
                                                    style="box-shadow: none;" @click="resetDate"><img
                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset-icon.svg"
                                                        style="width: 10px; height: 10px; margin-right: 6px;" />
                                                    Reset</button>
                                            </div>
                                        </div>
                                        <div class="col-12 mt-6 mb-4">
                                            <span style="font-weight: 600; font-size: 14px;">All Events</span>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-center w-100"
                                            v-if="!events.length ">
                                            <span class="fw-600 fs-18">No Events Found!</span>
                                        </div>
                                        <div class="col-6 my-4" v-for="(data,index) in events" :key="index">
                                            <div class="dataTab d-flex flex-row align-items-center">
                                                <div class="d-flex flex-column justify-content-center text-center px-3"
                                                    style="height: 100%; border-right: 1px solid #cdd2da;">
                                                    <div class="d-flex flex-column" style="width: 70px;">
                                                        <span
                                                            class="blueCalendarTop">{{data.start_date_time.month || "-"}}</span>
                                                        <span
                                                            class="blueCalendarBottom">{{data.start_date_time.dateNum || "-"}}</span>
                                                    </div>
                                                    <span class="mt-5 mb-1"
                                                        style="color: #0d5be6; font-size: 14px; line-height: 14px;">{{data.start_date_time.day || "-"}}</span>
                                                    <span
                                                        style="color: #0d5be6; font-size: 10px; line-height: 10px;">{{data.start_date_time.time || "-"}}
                                                        {{data.start_date_time.ampm}}</span>
                                                </div>
                                                <div class="d-flex flex-column mx-3 w-100" style="overflow: hidden;">
                                                    <span class="d-flex justify-content-between mt-1"
                                                        style="line-height: 20px; font-size: 15px; font-weight: 600;">
                                                        <el-tooltip class="item" effect="light" :content="data.name"
                                                            placement="top">
                                                            <span
                                                                style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ data.name }}</span>
                                                        </el-tooltip>
                                                        <a @click="deleteReminder(data._id)" style="cursor: pointer">
                                                            <img class="mr-1"
                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/trash-red.svg"
                                                                style="height: 12px;" />
                                                        </a>
                                                    </span>
                                                    <span class="mt-1"
                                                        style="line-height: 20px; font-size: 13px;">{{ data.event_type }}</span>
                                                    <el-dropdown trigger="click" :hide-on-click="true"
                                                        style="width: 10em;">
                                                        <span>
                                                            <div class="d-flex align-items-center mt-1"
                                                                style="line-height: 15px;">
                                                                <div v-for="(item,index) in data.invitee_details"
                                                                    :key="index">
                                                                    <span v-if="index <= 2">
                                                                        <img style="width: 15px;"
                                                                            :src="item.profile_pic" />
                                                                    </span>
                                                                    <span v-if="index == 3"
                                                                        style="line-height: 20px; font-size: 13px;">+{{data.invitee_details.length - 3}}</span>
                                                                    <span v-else></span>
                                                                </div>
                                                            </div>
                                                        </span>
                                                        <el-dropdown-menu slot="dropdown"
                                                            style="max-height: 10em; overflow-y: auto; border-radius: 0 !important; width: 12em;">
                                                            <el-dropdown-item
                                                                v-for="(item,index) in data.invitee_details"
                                                                :key="index" class="d-flex align-items-center px-2">
                                                                <img class="mr-2" style="width: 15px;"
                                                                    :src="item.profile_pic" />{{item.full_name || "-"}}
                                                            </el-dropdown-item>
                                                        </el-dropdown-menu>
                                                    </el-dropdown>
                                                    <div class="d-flex">
                                                        <span class="mt-1"
                                                            style="line-height: 20px; font-size: 13px; width: 12em;">Remind
                                                            Before : </span>
                                                        <div class="d-flex flex-wrap">
                                                            <span class="greenChip mt-1"
                                                                v-if="data.remind_before">{{data.remind_before[0].number || "-"}}
                                                                {{data.remind_before[0].gap || "-"}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 my-4">
                                            <button type="button"
                                                class="btn btn-new-primary btn-smm d-flex align-items-center float-right mr-2"
                                                style="box-shadow: none;" @click="createEvent">+ Create Event</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <create-event v-if="eventCreation" modal_name="create_event_modal" @hideCreateEvent="hideCreateEvent"
            @saveCreateEvent="saveCreateEvent"></create-event>
        <save-profile-data modal_name="save_profile_data" @updateUserData="updateUserData"></save-profile-data>
    </div>
</template>

<script>
    import CreateEvent from "./CreateEvent";
    import SaveProfileData from "./alertModals/SaveProfileData";
    import moment from "moment";
    import {
        User
    } from "./mixins/user";
    import QrcodeVue from "qrcode.vue";
    import VueTextareaAutosize from "vue-textarea-autosize";
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import {
        EventBus
    } from "./eventBus/nav-bar-event.js";
    import Swal from 'sweetalert2';
    const {
        uuid
    } = require('uuidv4');
    import axios from "axios";
    export default {
        data() {
            const value2date = (dateRange) => {
                const date = new Date(dateRange)
                return dateRange ? new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000) : null
            }
            const date2value = (date) => {
                return date ? new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000) : null
            }
            return {
                valueType: {
                    value2date,
                    date2value
                },
                toView: "birthdayView",
                editData: [],
                add_birthdays: [],
                edit_birthdays: [],
                relations: [
                    "Daughter",
                    "Father",
                    "Mother",
                    "Son"
                ],
                birthday_loading: false,
                birthdays: [],
                events: [],
                pickDate: false,
                dateRange: "",
                datePickShortcuts: [{
                        text: "Today",
                        onClick: () => this.shortcut("Today")
                    },
                    {
                        text: "This Week",
                        onClick: () => this.shortcut("This Week")
                    },
                    {
                        text: "This Month",
                        onClick: () => this.shortcut("This Month")
                    },
                    {
                        text: "This Year",
                        onClick: () => this.shortcut("This Year")
                    },
                ],
                selectedDate: new Date().getFullYear(),
                eventCreation: false,
                check_birthday_date: false,
            }
        },
        mixins: [User],
        components: {
            QrcodeVue,
            VueTextareaAutosize,
            HalfCircleSpinner,
            CreateEvent,
            SaveProfileData,
            Swal
        },
        methods: {
            updateUserData() {
                this.eventCreation = false;
                setTimeout(() => {
                    this.$modal.hide("create_event_modal");
                }, 500);
                EventBus.$emit("eventCreated")
            },
            moment(date) {
                return moment(date);
            },
            changeView(view) {
                this.toView = view;
            },
            async deleteBirthday(_id, index) {
                if (_id) {
                    let res = await this.$http.get("/events/birthday/delete?id=" + _id);
                    if (res.data.status_id == 1) {
                        this.getBirthdays();
                    }
                } else {
                    this.birthdays.splice(index, 1);
                    if (this.add_birthdays.includes(index)) {
                        this.add_birthdays = this.add_birthdays.filter(x => x != index);
                    }
                    if (this.edit_birthdays.includes(index)) {
                        this.edit_birthdays = this.edit_birthdays.filter(x => x != index);
                    }
                }
            },
            async deleteAllBirthdays() {
                this.birthdays.forEach((x, index) => {
                    if (!("_id" in x)) {
                        this.birthdays = this.birthdays.filter(i => i != x);
                    }
                });
                let res = await this.$http.get("/events/birthday/delete_all");
                if (res.data.status_id == 1) {
                    this.getBirthdays();
                }
                this.add_birthdays = [];
                this.edit_birthdays = [];
            },
            async deleteReminder(_id) {
                let res = await this.$http.get("/events/delete?id=" + _id);
                if (res.data.status_id == 1) {
                    this.getEvents();
                }
            },
            addBirthday() {
                this.birthdays.push({
                    common_id: uuid(),
                    profile_pic: "https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png",
                    name: "",
                    date_of_birth: "",
                    relationship: "",
                });
                this.add_birthdays.push(this.birthdays[this.birthdays.length - 1].common_id);
            },
            shortcut(type) {
                switch (type) {
                    case "Today":
                        this.dateRange = [new Date(), new Date()];
                        this.selectedDate = "Today's Events";
                        this.getEventsFiltered("from_shortcuts");
                        break;
                    case "This Week":
                        let startDateWeek = new Date().getDate() - new Date().getDay();
                        let lastDateWeek = startDateWeek + 6;
                        this.dateRange = [new Date(new Date().setDate(startDateWeek)), new Date(new Date().setDate(
                            lastDateWeek))];
                        this.selectedDate = "This Week's Events";
                        this.getEventsFiltered("from_shortcuts");
                        break;
                    case "This Month":
                        let startDateMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
                        let lastDateMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
                        this.dateRange = [startDateMonth, lastDateMonth];
                        this.selectedDate = "This Month's Events";
                        this.getEventsFiltered("from_shortcuts");
                        break;
                    case "This Year":
                        let startDateYear = new Date(new Date().getFullYear(), 0, 1);
                        let lastDateYear = new Date(new Date().getFullYear(), 11, 31);
                        this.dateRange = [startDateYear, lastDateYear];
                        this.selectedDate = new Date().getFullYear();
                        this.getEventsFiltered("from_shortcuts");
                        break;
                    default:
                        break;
                }
            },
            resetDate() {
                this.dateRange = "";
                this.selectedDate = new Date().getFullYear();
                this.getEvents();
            },
            createEvent() {
                this.eventCreation = true;
                setTimeout(() => {
                    this.$modal.show("create_event_modal");
                }, 500);
            },
            hideCreateEvent() {
                this.$modal.hide("create_event_modal");
            },
            saveCreateEvent() {
                this.$modal.show("save_profile_data");
            },
            editBirthday(index) {
                if (!("common_id" in this.birthdays[index])) {
                    Object.assign(this.birthdays[index], {
                        common_id: uuid(),
                    });
                }
                this.edit_birthdays.push(this.birthdays[index].common_id);
                // console.log(this.edit_birthdays)
            },
            async saveBirthdays(value) {
                this.$validator.validateAll().then(async result => {
                    if (result) {
                        if (this.birthdays.length) {
                            let edit = {
                                birthdays: []
                            };
                            let add = {
                                birthdays: []
                            };
                            let success = 0;
                            if (this.birthdays.length > 0) {
                                this.birthdays.forEach(x => {
                                    if ("common_id" in x) {
                                        if ("_id" in x) {
                                            edit.birthdays.push(x);
                                        } else {
                                            add.birthdays.push(x);
                                        }
                                    }
                                });
                            }
                            this.birthdays.forEach(x => {
                                if ("common_id" in x) {
                                    delete x["common_id"];
                                }
                            });
                            if (edit.birthdays.length > 0) {
                                let res = await this.$http.post("/events/birthday/edit", edit);
                                if (res.data.status_id == 1) {
                                    success += 1;
                                }
                            }
                            if (add.birthdays.length > 0) {
                                let res = await this.$http.post("/events/birthday/add", add);
                                if (res.data.status_id == 1) {
                                    success += 1;
                                }
                            }
                            if (this.edit_birthdays.length > 0 && this.add_birthdays.length > 0 &&
                                success === 2) {
                                this.birthdays = [];
                                this.$emit("dataSaved");
                            } else if (this.edit_birthdays.length > 0 || this.add_birthdays.length >
                                0 && success === 1) {
                                this.birthdays = [];
                                this.$emit("dataSaved");
                            } else {
                                this.$emit("dataSaved");
                            }
                        } else {
                            this.$emit("dataSaved");
                        }
                    } else {
                        this.$swal({
                            title: "WARNING",
                            text: "Birth Details are Required",
                            type: "warning",
                            showCancelButton: true,
                            showConfirmButton: false,
                            cancelButtonText: "OK",
                        }).then(result => {
                            if (result.value) {}
                        });
                    }
                })
            },
            async getBirthdays() {
                this.birthday_loading = true;
                const params = {
                    limit: 10,
                    search_key: "",
                    skip: 0,
                };
                let res = await this.$http.post("/events/birthday/list", params);
                if (res.data.status_id == 1) {
                    this.birthdays = res.data.response;
                    this.birthday_loading = false;
                }
            },
            async getEventsFiltered(from_shortcuts) {
                const params = {
                    limit: 10,
                    event_from: "",
                    event_till: "",
                    skip: 0,
                };
                if (!from_shortcuts) {
                    params.event_from = new Date(new Date(this.dateRange[0]).getTime() + 1000 * 60 * 60 * 24);
                    params.event_till = new Date(new Date(this.dateRange[1]).getTime() + 1000 * 60 * 60 * 24);
                } else {
                    params.event_from = this.dateRange[0];
                    params.event_till = this.dateRange[1];
                }
                let res = await this.$http.post("/events/event_between_dates", params);
                if (res.data.status_id == 1) {
                    this.events = res.data.response;
                    this.events.forEach(x => {
                        if ("start_date_time" in x) {
                            if (x.start_date_time.date && x.start_date_time.time) {
                                let startDate = x.start_date_time.date;
                                let pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
                                let formattedDate = new Date(startDate.replace(pattern, '$3-$2-$1'));
                                let date = startDate.split("/");
                                let time = x.start_date_time.time.split(":");
                                Object.assign(x.start_date_time, {
                                    month: formattedDate.toLocaleString('default', {
                                        month: 'short'
                                    }),
                                    dateNum: date[0],
                                    day: formattedDate.toLocaleString('default', {
                                        weekday: 'long'
                                    }),
                                    ampm: time[0] >= 12 ? "pm" : "am",
                                });
                            }
                        }
                        if (!"event_schedule" in x) {
                            Object.assign(this.reminders, {
                                event_schedule: {
                                    start_date: "",
                                    end_date: "",
                                    all_day: false,
                                }
                            });
                        }
                        if (x.event_schedule && x.event_schedule == {}) {
                            x.event_schedule = {
                                start_date: "",
                                end_date: "",
                                all_day: false,
                            }
                        }
                        if (!"repeat_cycle" in x) {
                            Object.assign(this.reminders, {
                                repeat_cycle: {
                                    start: "",
                                    end: "",
                                    cycle: {
                                        number: 0,
                                        gap: "",
                                    }
                                }
                            });
                        }
                        if (x.repeat_cycle && x.repeat_cycle == {}) {
                            x.repeat_cycle = {
                                start: "",
                                end: "",
                                cycle: {
                                    number: 0,
                                    gap: "",
                                }
                            }
                        }
                        if (!"remind_before" in x) {
                            Object.assign(this.reminders, {
                                remind_before: [{
                                    number: 0,
                                    gap: "",
                                }]
                            });
                        }
                        if (x.remind_before && x.remind_before.length === 0) {
                            x.remind_before.push({
                                number: 0,
                                gap: "",
                            });
                        }
                    });
                }
            },
            async getEvents() {
                let params = {
                    limit: 10,
                    skip: 0,
                    search_key: "",
                };
                let res = await this.$http.post("/events/list", params);
                if (res.data.status_id == 1) {
                    this.events = res.data.response;
                    this.events.forEach(x => {
                        if ("start_date_time" in x) {
                            if (x.start_date_time.date && x.start_date_time.time) {
                                let startDate = x.start_date_time.date;
                                let pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
                                let formattedDate = new Date(startDate.replace(pattern, '$3-$2-$1'));
                                let date = startDate.split("/");
                                let time = x.start_date_time.time.split(":");
                                Object.assign(x.start_date_time, {
                                    month: formattedDate.toLocaleString('default', {
                                        month: 'short'
                                    }),
                                    dateNum: date[0],
                                    day: formattedDate.toLocaleString('default', {
                                        weekday: 'long'
                                    }),
                                    ampm: time[0] >= 12 ? "pm" : "am",
                                });
                            }
                        }
                        if (!"event_schedule" in x) {
                            Object.assign(this.reminders, {
                                event_schedule: {
                                    start_date: "",
                                    end_date: "",
                                    all_day: false,
                                }
                            });
                        }
                        if (x.event_schedule && x.event_schedule == {}) {
                            x.event_schedule = {
                                start_date: "",
                                end_date: "",
                                all_day: false,
                            }
                        }
                        if (!"repeat_cycle" in x) {
                            Object.assign(this.reminders, {
                                repeat_cycle: {
                                    start: "",
                                    end: "",
                                    cycle: {
                                        number: 0,
                                        gap: "",
                                    }
                                }
                            });
                        }
                        if (x.repeat_cycle && x.repeat_cycle == {}) {
                            x.repeat_cycle = {
                                start: "",
                                end: "",
                                cycle: {
                                    number: 0,
                                    gap: "",
                                }
                            }
                        }
                        if (!"remind_before" in x) {
                            Object.assign(this.reminders, {
                                remind_before: [{
                                    number: 0,
                                    gap: "",
                                }]
                            });
                        }
                        if (x.remind_before && x.remind_before.length === 0) {
                            x.remind_before.push({
                                number: 0,
                                gap: "",
                            });
                        }
                    });
                }
            },
            onProfilePicChange(e, index) {
                var input = event.target;
                if (input.files && input.files[0]) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.files[0].name,
                        size: JSON.stringify(input.files[0].size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: "",
                    };
                    this.getResumableURL(input.files[0], attachment, index);
                }
            },
            getResumableURL(file, attachment, index) {
                let vuethis = this;
                let data = {
                    file: attachment.name,
                };
                data = new FormData();
                data.append("file", file);
                this.$http.post("https://cloudapis.digicollect.com/external/upload_file", data)
                    .then(response => {
                        vuethis.birthdays[index].profile_pic = response.data.url;
                        this.$awn.success("Uploaded Successfully");
                    }).catch(error => {
                    });
            },
        },
        watch: {
            toView: function (val) {
                if (val === "eventsView") {
                    this.$emit("editEvents");
                } else {
                    this.$emit("closeEditEvents");
                }
            }
        },
        created() {
            this.getBirthdays();
            this.getEvents();
            const dict = {
                custom: {
                    // leadcontactnumber: {
                    //     required: () => 'This Field is Required',
                    //     min: () => 'Invalid Phone Number'
                    // },
                }
            }
            this.$validator.localize('en', dict)
        },
        mounted() {
            EventBus.$on("remindersInformation", () => {
                if (this.toView === "birthdayView") {
                    // this.check_birthday_date = false;
                    // this.birthdays.forEach(x=>{
                    //     if(x.date_of_birth == '' || x.name == '') {
                    //         this.check_birthday_date = true;
                    //     }
                    // });
                    this.saveBirthdays();
                } else if (this.toView === "eventsView") {
                    this.$emit("dataSaved");
                }
            });
            EventBus.$on("hideuser", () => {
                this.hideEdit();
            });
        },
        destroyed() {
            EventBus.$off("remindersInformation");
        },
        computed: {
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
        },
    }
</script>

<style scoped>
    .top-tabs-reminders {
        border: 1px solid #707070;
        border-radius: 8px;
        background: transparent;
        color: #3f3f3f !important;
        font-size: 15px;
        cursor: pointer;
        width: 100%;
    }

    .top-tabs-reminders:hover {
        border: 1px solid #005dae;
        background: #005dae;
        color: #ffffff !important;
    }

    .top-tabs-reminders-disabled {
        border: 1px solid rgba(0, 0, 0, 0.32);
        border-radius: 8px;
        background: transparent;
        color: rgba(0, 0, 0, 0.32) !important;
        font-size: 15px;
        width: 100%;
    }

    .active {
        border: 1px solid #005dae;
        background: #005dae;
        color: #ffffff !important;
    }

    .dataTab {
        /* border: 1px solid #707070; */
        border-radius: 6px;
        color: #3f3f3f;
        box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.41);
        height: 10em;
    }

    .greenChip {
        background: rgb(18, 136, 7) none repeat scroll 0% 0%;
        color: rgb(255, 255, 255);
        border-radius: 20px;
        height: 18px;
        line-height: 18px;
        font-size: 12px;
        text-align: center;
        width: 5.2em;
        margin-right: 5px;
    }

    .blueCalendarTop {
        background: #0d5be6;
        color: #fff;
        font-weight: 600;
        border: 3px solid #abc1e5;
        border-radius: 5px 5px 0px 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 2em;
    }

    .blueCalendarBottom {
        background: #0d5be6;
        color: #fff;
        font-weight: 800;
        border: 3px solid #abc1e5;
        border-radius: 0px 0px 5px 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 2.3em;
        font-size: 15px;
        border-top: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/EditRemindersView.vue